
export const MINISTERE_TRAVAIL_URL = 'https://travail-emploi.gouv.fr/';
export const FRANCE_COMPETENCES_URL = 'https://www.francecompetences.fr/';